import PropTypes from 'prop-types'
import React from 'react'
import { push } from 'react-router-redux'
import cx from 'classnames'

import { show, hide } from 'store/reducers/modals'

import { createNewPath } from 'helpers/components'
import moment, { urlFormat, pastCutoff } from 'helpers/moment'

import Breadcrumb from 'components/Breadcrumb'
import Button from 'components/Button'
import DateComponent from 'components/Date'
import PricelistList from 'components/Pricelist/List'

import classes from './Pricelist.scss'

export class Pricelist extends React.Component {
  constructor (props) {
    super(props)

    this.state = { linkToSpecialOrderProduct: false }
  }

  componentDidMount () {
    if (this.props.baseUrl !== 'daily_products' && this.props.date && pastCutoff(this.props.date)) {
      this.props.dispatch(show('cutoff', { props: this.props }))
    } else if (this.props.date && !pastCutoff(this.props.date)) {
      this.props.dispatch(hide('cutoff'))
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.baseUrl !== 'daily_products' && nextProps.date !== this.props.date && nextProps.date && pastCutoff(nextProps.date)) {
      nextProps.dispatch(show('cutoff', { props: nextProps }))
    } else if (nextProps.date !== this.props.date && !pastCutoff(nextProps.date)) {
      nextProps.dispatch(hide('cutoff'))
    }

    if (nextProps.pricelist === this.props.pricelist && this.state.linkToSpecialOrderProduct) return // already set the link
    this.setState({ linkToSpecialOrderProduct: this.getLinkToSpecialOrderProduct(nextProps) })
  }

  isSpecialOrder = product => {
    if (!product) return false
    if (!product.name || typeof product.name.toLowerCase !== 'function') return false
    const productName = product.name.toLowerCase()

    return ['special order', 'offlist', 'off list', 'off-list'].some(name => productName.includes(name))
  };

  getLinkToSpecialOrderProduct = (props = this.props) => {
    const product = props.pricelist.find(product => this.isSpecialOrder(product))
    if (!product || !product.product_id) return false

    return createNewPath(props.date, 'orders', props, {
      append: `?product_id=${product.product_id}`,
      action: 'new'
    })
  };

  renderCartButton = () => {
    if (!this.props.showCart || !this.props.staging.length) return null

    return <Button stick stickOptions={{ hideUnstuck: true }}
      options={['red', 'block']}
      onlyOnce={false}
      callback={(e) => {
        e.stopPropagation()
        this.props.dispatch(push(
          `/orders${(this.props.date && `/${moment(this.props.date).format(urlFormat)}` || '')}/list`
        ))
      }}
    >
      View Cart{this.props.staging.length && ` (${this.props.staging.length})` || ''}
    </Button>
  };

  render () {
    const className = cx({
      [classes['collection']]: classes['collection'],
      [classes['collection--three-fifths']]: this.props.partial && classes['collection--three-fifths']
    })

    const headerClassName = cx({
      [classes['header']]: classes['header'],
      [classes['header--large']]: !this.props.editing && !this.props.partial && classes['header--large']
    })

    return (
      <div className={className}>
        <header className={headerClassName}>
          {!this.props.editing && !this.props.partial &&
            (document.referrer.includes('www.twoxsea.com') || document.referrer.includes('//twoxsea.com')) &&
            <Breadcrumb onClick={() => (history.back())}>
              Go Back to TwoXSea.com
            </Breadcrumb>
          }

          <div className={classes['header-title']}>
            {this.props.partial && 'Current Pricelist'}
            {!this.props.partial && moment(this.props.date).format() === moment(new Date()).format() && 'Current Pricelist'}
            {!this.props.partial && moment(this.props.date).format() !== moment(new Date()).format() && 'Pricelist'}

            <span className={classes['header-title--sub']}>
              <DateComponent {...this.props}
                date={this.props.date}
                textFormat='for {0}'
                baseUrl={this.props.baseUrl}
              />
            </span>

            {!this.props.editing && <span className={classes['header-title--note']}>
              <p>
                {this.props.isLoggedIn && 'Trouble ordering? C' || 'To order, c'}all or text us at <mark>(415) 275-2292</mark>
              </p>
            </span>}
          </div>

          {this.props.isAdmin && <div className={classes['header-buttons']}>
            <Button
              element='a'
              options={['green', 'small']}
              href={`/daily_products${(this.props.date ? `/${moment(this.props.date).format(urlFormat)}` : '')}/new`}
            >
              {this.props.editing && 'Add New' || 'Manage Pricelist'}
            </Button>

            {this.props.editing && <Button
              element='a'
              options={['blue', 'small']}
              href={`/pricelist${(this.props.date ? `/${moment(this.props.date).format(urlFormat)}` : '')}`}
            >
              View Pricelist
            </Button>}
          </div>}
        </header>

        <PricelistList
          {...this.props}
          showLastUpdated
          notUpdatedMessage='Pricelist not yet updated.'
        >
          {!this.props.editing && !this.props.partial && this.props.isLoggedIn &&
            <div className={classes.start}>Select a product below to start your order.</div>
          }

          <div className={classes.buttons}>
            {!this.props.editing && !this.props.partial && this.props.isLoggedIn && this.props.user && this.props.user.can_special_order &&
              this.state.linkToSpecialOrderProduct &&
              <Button
                element='a'
                options={['red']}
                href={this.state.linkToSpecialOrderProduct}
              >
                Request Off List Item
              </Button>
            }

            {!this.props.editing && !this.props.partial && <Button
              options={['purple', 'mobile']}
              callback={() => this.props.dispatch(show('feedback'))}
            >
              Questions?
            </Button>}
          </div>
        </PricelistList>

        {this.renderCartButton()}
      </div>
    )
  }
}

Pricelist.propTypes = {
  staging: PropTypes.array,
  showCart: PropTypes.bool,

  pricelist: PropTypes.array.isRequired,
  options: PropTypes.array.isRequired,
  uoms: PropTypes.array.isRequired,

  partial: PropTypes.bool,
  editing: PropTypes.bool,
  params: PropTypes.object,
  date: PropTypes.any,
  baseUrl: PropTypes.string,
  isLoggedIn: PropTypes.bool,
  isAdmin: PropTypes.bool,
  user: PropTypes.object,

  put: PropTypes.func,
  post: PropTypes.func,

  location: PropTypes.object,
  dispatch: PropTypes.func.isRequired
}

Pricelist.defaultProps = {
  showCart: true,
  staging: [],
  options: [],
  uoms: [],
  pricelist: [],
  partial: false,
  editing: false,

  isLoggedIn: false,
  isAdmin: false,

  baseUrl: 'pricelist'
}

export default Pricelist



// WEBPACK FOOTER //
// ./src/components/Pricelist/Pricelist.js